"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileHeader = void 0;
const CompanyProfileHeader_1 = require("./CompanyProfileHeader");
Object.defineProperty(exports, "CompanyProfileHeader", { enumerable: true, get: function () { return CompanyProfileHeader_1.CompanyProfileHeader; } });
